import angular from 'angular';

angular
  .module('cloudX')
  .controller('CalcDistanceDialogCtrl', [
    '$element',
    '$q',
    '$translate',
    'googleMapsSvc',
    'resourceFactorySvc',
    'flySvc',
    'userData',
    'dataCache',
    '$http',
    'appUrls',
    'close',
    'relationId',
    'companyId',
    calcDistanceDialogCtrl,
  ]);

function calcDistanceDialogCtrl(
  $element,
  $q,
  $translate,
  googleMapsSvc,
  resourceFactorySvc,
  flySvc,
  userData,
  dataCache,
  $http,
  appUrls,
  close,
  relationId,
  companyId,
) {
  var vm = this;
  vm.from = {
    value: '',
    list: [],
  };
  vm.to = {
    value: '',
    list: [],
  };
  var settings = userData.get('distanceDialog', {
    singleTravel: true,
    addRoute: true,
  });
  var profile = dataCache.getArray('employee');

  vm.singleTravel = profile.travelOneWay ? 1 : 2;
  vm.addRoute = settings.addRoute;
  vm.calculating = false;
  vm.result = null;
  vm.noRelAddress = false;
  vm.noCompAddress = false;

  var getAddressString = function(address) {
    return [
      address.street1,
      ' ',
      address.number,
      address.box ? '/' + address.box : '',
      ', ',
      address.zipCode,
      ' ',
      address.city,
      ', ',
      address.country,
    ].join('');
  };

  var init = () => {
    const companyAddressPromise = $http.get(`${appUrls.api}/api/company/addresses`);
    const relationAddressPromise = $http.get(`${appUrls.api}/api/address/${relationId}`);
    Promise.all([companyAddressPromise, relationAddressPromise]).then(
      ([{ data: companyAddresses }, { data: relationAddresses }]) => {
        companyAddresses
          .filter(x => x.street1)
          .forEach(companyAddress => {
            var address = getAddressString(companyAddress);
            if (vm.from.list.indexOf(address) < 0) vm.from.list.push(address);
            if (!!companyId && companyId === companyAddress.companyId) {
              vm.from.value = address;
            } else if (!companyId && dataCache.getArray('tenantId') === companyAddress.companyId) {
              vm.from.value = address;
            }
          });

        if (vm.from.list.length === 0) {
          vm.noCompAddress = true;
        } else if (!vm.from.value) {
          vm.from.value = vm.from.list[0];
        }

        relationAddresses.forEach(({ medium, postAddress, isMain = false }) => {
          if (medium !== 0) return;
          if (!postAddress || !postAddress.street1) return;
          var addr = getAddressString(postAddress);
          vm.to.list.push(addr);

          if (isMain) vm.to.value = addr;
        });

        if (vm.to.list.length === 0) {
          vm.noRelAddress = true;
        } else if (!vm.to.value) {
          vm.to.value = vm.to.list[0];
        }

        if (vm.canCalculate()) vm.calculate();
      },
    );
  };
  init();

  if (profile.employeeAddress && profile.employeeAddress.street1) {
    var emplAddr = getAddressString(profile.employeeAddress);
    vm.from.list.push(emplAddr);
    if (profile.travelFromHome || !vm.from.value) vm.from.value = emplAddr;
  }

  vm.flip = function() {
    var tmp = angular.copy(vm.from);
    vm.from = vm.to;
    vm.to = tmp;
  };

  vm.canCalculate = function() {
    if (vm.calculating) return false;
    if (!vm.from || !vm.from.value) return false;
    if (!vm.to || !vm.to.value) return false;
    return true;
  };
  vm.calculate = function() {
    if (!vm.canCalculate()) return;
    vm.calculating = true;
    vm.result = null;
    googleMapsSvc.getDistanceMatrix(vm.from.value, vm.to.value).then(
      function(result) {
        vm.result = result;
        vm.calculating = false;
      },
      function(error) {
        vm.result = {
          error: error,
        };
        flySvc.error(error);
        vm.calculating = false;
      },
    );
  };
  vm.clearResult = function() {
    vm.result = null;
  };

  vm.getDescription = function() {
    if (!vm.addRoute || !vm.result || vm.result.error) return null;
    var description = $translate.instant('Origin') + ': ' + vm.result.origin + '\n';
    description += $translate.instant('Destination') + ': ' + vm.result.destination + '\n';
    if (vm.singleTravel === 2)
      description += $translate.instant('and back') + ': ' + vm.result.origin + '\n';
    description +=
      $translate.instant('Distance') +
      ': ' +
      (vm.result.distance * vm.singleTravel).toFixed(2) +
      ' km';
    return description;
  };

  vm.updateSettings = function() {
    userData.set('distanceDialog', {
      singleTravel: vm.singleTravel,
      addRoute: vm.addRoute,
    });
  };

  vm.save = function() {
    close(
      {
        distance: vm.result.distance * vm.singleTravel,
        durationMinutes: vm.result.durationMinutes * vm.singleTravel,
        description: vm.getDescription(),
      },
      500,
    );
    $element.modal('hide');
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
